import { useMutation } from '@tanstack/react-query';

export function useCreateProjectsAnalyticsProjectsReportsProjectsCreatedReportsExportProcessMutation() {
  return useMutation({
    mutationKey: [
      'createProjectsAnalyticsProjectsReportsProjectsCreatedReportsExportProcess',
    ],
    mutationFn: async ({ params }) => {
      const response = await axios.post(
        '/projects_analytics/projects_reports/projects_created_reports/export_processes',
        { export_process: params },
      );

      return response.data;
    },
  });
}
